/**
 * Reload current page.
 */
export const reloadPage = () => window.location.reload();

/**
 * Navigate to new path in URL.
 */
export const navigateToPath = (path: string) => {
    window.location.href = path;
};

/**
 * Navigate to new search part of the URL.
 */
export const navigateToSearch = (search: string) => {
    window.location.search = search;
};

export default {
    reloadPage,
    navigateToPath,
};
